import React from 'react';
import { Typography, Box, Button } from '@mui/material';
import { motion, useInView } from "framer-motion";
import { MoreInfoType, ContentBlock, Project } from '../types';
import { projectData } from "../compontents/project/ProjectData";

export const sectionStyles = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#111111",
    minHeight: '100vh',
    width: '100%',
    position: 'relative', 
    zIndex: 2,
    color: 'white',
};

export const normalize = (str: string) =>
    str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');

export const fetchProjectByTitle = (title: string | undefined): (Project & { moreInfo: MoreInfoType[] }) | undefined => {
    if (!title) return undefined;

    const found = projectData.find(p => normalize(p.title) === title);

    return found
        ? { ...found, moreInfo: Array.isArray(found.moreInfo) ? found.moreInfo : [] }
        : undefined;
};

export const findAdjacentProjects = (currentIndex: number, data: Project[], count = 3): Project[] => {
    const total = data.length;
    const candidates = new Set<number>();

    // Define adjacent indexes
    const adjacentIndexes = [
        currentIndex - 1,
        currentIndex + 1,
        currentIndex - 2,
        currentIndex + 2,
    ];

    // Add adjacent projects
    for (const idx of adjacentIndexes) {
        if (idx >= 0 && idx < total && candidates.size < count) {
            candidates.add(idx);
        }
    }

    // Fill remaining if needed
    if (candidates.size < count) {
        for (let i = 0; i < total && candidates.size < count; i++) {
            if (i !== currentIndex && !candidates.has(i)) {
                candidates.add(i);
            }
        }
    }

    return Array.from(candidates).map(i => data[i]);
};
